module.exports = {
    "gwpTarget": {
        "twentytwentyfive": 2500,
        "twentythirty": 1400
    }
}